"use client";
import { styled } from "@mui/material/styles";
import { SizeBorderWidthThin, ColorGray200, ColorGray100, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const Container = styled(CostcoBox, {
  shouldForwardProp: (props) => props !== "bodyBackgroundColor" && props !== "ignoreBackground"
})(({ bodyBackgroundColor, ignoreBackground }) => {
  let styles = {
    ["@media (max-width:520px)"]: {
      width: `100%`
    },
    ["@media (max-width:1024px) and (min-width:520px)"]: {
      width: `calc((min(100vw, 1023px) / 2) - 44px)`
    },
    ["@media (min-width:1024px)"]: {
      width: `calc((min(100vw, 1400px) / 4) - 66px)`
    },
    display: "flex",
    flexDirection: "column",
    gap: SpaceMd,
    minHeight: "100%",
    minWidth: "100%",
    paddingBottom: SpaceMd,
    width: "100%"
  };
  if (!ignoreBackground) {
    styles = {
      ...styles,
      backgroundColor: bodyBackgroundColor ? bodyBackgroundColor : ColorGray100,
      border: `solid ${SizeBorderWidthThin} ${ColorGray200}`,
      borderRadius: "10px"
    };
  }
  return styles;
});
export {
  Container
};
